export const invoicesErrorMessage = "Une erreur s'est produite. Les factures n'ont pas été récupérées";
export const updateMessageError = "Une erreur s'est produite. Le message n'a pas été mis à jour";
export const updateMessageSuccess = "Le message a été mis à jour avec succès";

export const dataUpdatedSuccess = "Vos données ont été mises à jour avec succès";
export const dataUpdateFailed = "Une erreur s'est produite. Vos données n'ont pas été mises à jour";
export const updateSecuritySuccess = "Les paramètres de sécurité ont été mis à jour avec succès";
export const udpateSecurityFailed = "Une erreur s'est produite lors de la mise à jour de vos paramètres de sécurité";

export const inviteRepresentativeSuccess = "Représentant invité avec succès";
export const inviteRepresentativeFailed = "Invitation représentant non envoyée";

export const invoicePaidSuccess = "Facture payée avec succès";
export const invoicePaidFailed = "Erreur lors du paiement de la facture";


